import getCharts from '../getCharts'
import { PatientHistoryCRUD } from '../../constants/api.config'

export default async function ModifyPatientHistory(mode="GET", patientID="-1", history="", pdate="",id="-1" ) {
  try {
    const payload = {mode, patientID, history, pdate,id }
    const res = await getCharts(PatientHistoryCRUD, payload)
    return res.data
  } catch (error) {
    return error
  }
}
